// extracted by mini-css-extract-plugin
export var videoContainer = "_jq-0";
export var videoIframe = "_jq-3";
export var videoLink = "_jq-1";
export var videoOverlay = "_jq-4";
export var videoOverlayText = "_jq-5";
export var videoWrapper = "_jq-2";